import { Action } from '@ngrx/store';
import { IWindowActiveConfiguration } from '@icc/window-door/types';

export enum WindowDoorActionTypes {
    LoadWindowDoor = '[WindowDoor] Load WindowDoor',
    LoadWindowDoorFromStartState = '[WindowDoor] Load WindowDoor From Start State',
    LoadWindowDoorDefaultsFromStartState = '[WindowDoor] Load WindowDoor Defaults From Start State',
    LoadWindowDoorAllDefaults = '[WindowDoor] Load WindowDoor All Defaults',
    LoadWindowDoorConfiguration = '[WindowDoor] Load WindowDoor Configuration',
    WindowDoorLoaded = '[WindowDoor] WindowDoor Loaded',
    WindowDoorLoadError = '[WindowDoor] WindowDoor Load Error',
    SaveWindowDoorConfiguration = '[WindowDoor] Save WindowDoor Configuration',
    UpdateWindowDoorConfiguration = '[WindowDoor] Update WindowDoor Configuration',
}

export class LoadWindowDoor implements Action {
    readonly type = WindowDoorActionTypes.LoadWindowDoor;
}

export class WindowDoorLoadError implements Action {
    readonly type = WindowDoorActionTypes.WindowDoorLoadError;
    constructor(public payload: any) {}
}

export class LoadWindowDoorFromStartState implements Action {
    readonly type = WindowDoorActionTypes.LoadWindowDoorFromStartState;
    constructor(public payload: { startState: IWindowActiveConfiguration }) {}
}

export class LoadWindowDoorDefaultsFromStartState implements Action {
    readonly type = WindowDoorActionTypes.LoadWindowDoorDefaultsFromStartState;
    constructor(public payload: { startState: IWindowActiveConfiguration }) {}
}

export class LoadWindowDoorAllDefaults implements Action {
    readonly type = WindowDoorActionTypes.LoadWindowDoorAllDefaults;
}

export class LoadWindowDoorConfiguration implements Action {
    readonly type = WindowDoorActionTypes.LoadWindowDoorConfiguration;
    constructor(public payload: { configuration: IWindowActiveConfiguration }) {}
}

export class WindowDoorLoaded implements Action {
    readonly type = WindowDoorActionTypes.WindowDoorLoaded;
}

export class SaveWindowDoorConfiguration implements Action {
    readonly type = WindowDoorActionTypes.SaveWindowDoorConfiguration;
}

export class UpdateWindowDoorConfiguration implements Action {
    readonly type = WindowDoorActionTypes.UpdateWindowDoorConfiguration;
    constructor(public payload: { configuration: IWindowActiveConfiguration }) {}
}

export type WindowDoorAction =
    | LoadWindowDoor
    | WindowDoorLoaded
    | WindowDoorLoadError
    | LoadWindowDoorFromStartState
    | LoadWindowDoorDefaultsFromStartState
    | LoadWindowDoorAllDefaults
    | LoadWindowDoorConfiguration
    | UpdateWindowDoorConfiguration;

export const fromWindowDoorActions = {
    LoadWindowDoor,
    WindowDoorLoaded,
    WindowDoorLoadError,
    LoadWindowDoorFromStartState,
    LoadWindowDoorDefaultsFromStartState,
    LoadWindowDoorAllDefaults,
    LoadWindowDoorConfiguration,
    UpdateWindowDoorConfiguration,
};

// Legacy exports for backward compatibility
export const WindowActionTypes = WindowDoorActionTypes;
export const LoadWindow = LoadWindowDoor;
export const WindowLoaded = WindowDoorLoaded;
export const WindowLoadError = WindowDoorLoadError;
export const LoadWindowFromStartState = LoadWindowDoorFromStartState;
export const LoadWindowDefaultsFromStartState = LoadWindowDoorDefaultsFromStartState;
export const LoadWindowAllDefaults = LoadWindowDoorAllDefaults;
export const LoadWindowConfiguration = LoadWindowDoorConfiguration;
export const SaveWindowConfiguration = SaveWindowDoorConfiguration;
export const UpdateWindowConfiguration = UpdateWindowDoorConfiguration;
export type WindowAction = WindowDoorAction;
export const fromWindowActions = fromWindowDoorActions;
